<template>
  <base-property-icon-item :label="label">
    <template v-slot:icon>
      <bed-icon></bed-icon>
    </template>
  </base-property-icon-item>
</template>
<script>
import BasePropertyIconItem from './BasePropertyIconItem.vue';
import BedIcon from '../Icons/BedIcon.vue';
export default {
  props: ['label'],
  components: {
    BasePropertyIconItem,
    BedIcon
  },
};
</script>
